import React from 'react';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = '',
    icon: Icon,
}) => {
    const baseClasses = 'inline-flex items-center justify-center gap-2 font-medium tracking-wider uppercase rounded-none transition-all duration-300 cursor-pointer border-2';

    const variants = {
        primary: 'bg-[#2563EB] border-[#2563EB] text-white hover:bg-[#1D4ED8] hover:border-[#1D4ED8]',
        secondary: 'bg-transparent border-[#2563EB] text-[#2563EB] hover:bg-[#2563EB] hover:text-white',
        dark: 'bg-[#0F172A] border-[#0F172A] text-white hover:bg-[#1E293B] hover:border-[#1E293B]',
        ghost: 'bg-transparent border-transparent text-[#2563EB] hover:bg-[#F8FAFC]',
        danger: 'bg-red-600 border-red-600 text-white hover:bg-red-700 hover:border-red-700',
    };

    const sizes = {
        sm: 'px-4 py-2 text-xs',
        md: 'px-6 py-3 text-sm',
        lg: 'px-8 py-3.5 text-sm',
        xl: 'px-10 py-4 text-base',
    };

    const widthClass = fullWidth ? 'w-full' : '';
    const disabledClass = disabled ? 'opacity-50 cursor-not-allowed' : '';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseClasses} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${widthClass} ${disabledClass} ${className}`}
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
            {Icon && <Icon className="w-4 h-4" />}
            {children}
        </button>
    );
};

export default Button;
